module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaCAYAAACHD21cAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAsUlEQVQ4y6XUMQpCMQzG8T+O4igofbi6egEXD+HsaQQfKIqCoI7ibRzFQXTTczwHM2TMFwOl04+mbRKAETADOoixABrgosIx8DZ8VHEB7oZPKh4AT8N7FfeAVxYX4JbFFfAwvFVx1+GNivsubRkXd/Lqn7SXKm4DV8N1S4CNLdwupRq+p3+cdRSlvsOnF66eVMn5It9FUaqtUo3sR8chiibAh8Swmhs6KwhgCEz5FXE4vhq/PX5eDdM7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jt.png
// module id = DmtO
// module chunks = 1